import { useApp } from "../store";
import { EmptyState, PageHeader } from "../components/UI";

import "../css/Notifications.css";
export default function Notifications() {
  const { notifications } = useApp();

  return (
    <div className="page-wrap narrow container-xl">
      <PageHeader
        title="Notifications"
        copy="Fresh updates about your schedules and deliveries."
      />
      <div className="notification-list">
        {notifications.length ? (
          notifications.map((notification) => (
            <article
              key={notification.id}
              className={notification.unread ? "unread" : ""}
            >
              <span>
                <i className={`fa-solid ${notification.icon || "fa-bell"}`} />
              </span>
              <div>
                <div className="d-flex justify-content-between gap-2">
                  <h3>{notification.title}</h3>
                  <small>{notification.time}</small>
                </div>
                <p>{notification.body}</p>
              </div>
            </article>
          ))
        ) : (
          <EmptyState
            icon="fa-bell-slash"
            title="No notifications"
            copy="New delivery updates will appear here."
          />
        )}
      </div>
    </div>
  );
}
